import { FC, useState } from 'react';
import {
  DynamicHeatmapDrawerContext,
  DynamicHeatmapDrawerContextState,
} from './DynamicHeatmapDrawerContext';

export const DynamicHeatmapDrawerContextProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const collapse = () => {
    setIsExpanded(false);
  };
  const expand = () => {
    setIsExpanded(true);
  };

  const toggle = () => {
    setIsExpanded(!isExpanded);
  };

  const context: DynamicHeatmapDrawerContextState = {
    collapse,
    expand,
    toggle,
    isExpanded,
  };

  return (
    <DynamicHeatmapDrawerContext.Provider value={context}>
      {children}
    </DynamicHeatmapDrawerContext.Provider>
  );
};
